/**
 * Types of alerts.
 */
export enum enumAlert{
    None = "",
    Dark = "dark",
    Danger = "danger",
    Info = "info",
    Light = "light",
    Primary = "primary",
    Secondary = "secondary",
    Success = "success",
    Warning = "warning"
};